import z from "zod"

export const IMPORTER_ACCEPTED_MIME_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/xls",
  "application/vnd.ms-excel",
  "text/csv",
  ".csv",
]

export const S3_UPLOAD_INPUT_FORMATS = z.enum(["IMAGE", "VIDEO", "GIF", "DOCUMENT", "AUDIO"])

export const KNOWLEDGE_BASE_FORMAT = {
  "application/pdf": "application/pdf",
  "text/markdown": "text/markdown",
  "text/plain": "text/plain",
} as const

export const KNOWLEDGE_BASE_FORMAT_COPIES = {
  [KNOWLEDGE_BASE_FORMAT["application/pdf"]]: "pdf",
  [KNOWLEDGE_BASE_FORMAT["text/markdown"]]: "md",
  [KNOWLEDGE_BASE_FORMAT["text/plain"]]: "txt",
} as const satisfies Record<keyof typeof KNOWLEDGE_BASE_FORMAT, string>

export const MediaMessageFormatEnum = {
  Audio: "Audio",
  Image: "Image",
  Video: "Video",
  Document: "Document",
} as const

export type MediaMessageFormat =
  (typeof MediaMessageFormatEnum)[keyof typeof MediaMessageFormatEnum]
